export default __webpack_public_path__ + "static/media/RGUHS.5065115b.png";